import React from "react";

function OrangeCalender() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="12"
      viewBox="0 0 17 12"
      fill="none"
    >
      <path
        opacity="0.5"
        d="M16.8331 4.66674V3.00007C16.8331 2.30087 16.8304 1.05439 16.8196 0.5H0.174469C0.163717 1.05439 0.166434 2.30087 0.166434 3.00007V4.66674C0.166434 7.80943 0.166434 9.38078 1.14274 10.3571C2.11906 11.3334 3.6904 11.3334 6.8331 11.3334H10.1664C13.3091 11.3334 14.8805 11.3334 15.8568 10.3571C16.8331 9.38078 16.8331 7.80943 16.8331 4.66674Z"
        fill="#DAAE3E"
      />
    </svg>
  );
}

export default OrangeCalender;
